(function () {
  'use strict';
  angular.module('vcfinance.privcat')
    .component('privcatnewgroup', {
      restrict: 'E',
      bindings: {
      },
      template: `
      <div class="privcatnewgroup-component" data-hook="privcatnewgroup-component">
        <h3>Neue Leistungsgruppe anlegen</h3>
        <div class="btn btn-success" style="margin-bottom: 12px"
        ng-click="vm.addPrivcatGroup()" ng-hide="vm.newprivcatgroup">Neue Leistungsgruppe anlegen</div>
        <div ng-show="vm.newprivcatgroup">
          <privcatgroupform privcatgroup="vm.newprivcatgroup" parentsave="vm.saveNewPrivcatGroup(privcatgroup)" oncancel="vm.cancel()"></privcatgroupform>
        </div>
        <div ng-show="vm.created === true" class="alert alert-success spacer-top spacer-bottom">
          <h3><i class="fa fa-check"></i> Leistungsgruppe erfolgreich angelegt!</h3>
        </div>
        <div ng-show="vm.canceled === true" class="alert alert-info spacer-top spacer-bottom">
          <h3><i class="fa fa-info-circle"></i> Das Anlegen einer neuen Leistungsgruppe wurde abgebrochen!</h3>
        </div>
        <div ng-show="vm.created === false" class="alert alert-danger spacer-top spacer-bottom">
          <h3>
            <i class="fa fa-warning"></i> Leistungsgruppe konnte nicht angelegt werden,
            der Fehler wurde protokolliert!
            </h3>
        </div>
      </div>
      `,
      controllerAs: 'vm',
      controller: ['$log', 'Privcat', 'Rlog',
        function ($log, Privcat, Rlog) {
          let vm = this;
          vm.addPrivcatGroup = addPrivcatGroup;
          vm.saveNewPrivcatGroup = saveNewPrivcatGroup;
          vm.cancel = cancel;


          function addPrivcatGroup() {
            vm.newprivcatgroup = {
              type: 'group'
            };
            delete vm.created;
            delete vm.canceled;
          }
          
          function saveNewPrivcatGroup(privcatgroup) {
            $log.debug('debug: create new privcat: ', privcatgroup);
            delete vm.newprivcatgroup;
            Privcat.$create(privcatgroup).$then(function () {
              vm.created = true;
            }, function (err) {
              vm.created = false;
              $log.error('Creation of new privcatgroup failed: ', err);
              Rlog.error('vcutils.privcat', 'privcatgroupnew', 'Creation of new privcatgroup failed: ', {privcatgroup: privcatgroup});
            });
          }
          
          function cancel() {
            delete vm.newprivcatgroup;
            vm.canceled = true;
          }
        }] // controller
    }); // component

// klammerfriedhof
}());